export default "__VITE_ASSET__d18a7665__"